module.exports = __webpack_public_path__ + "img/118.a43c8cc3.jpg";